import { makePostRequest } from 'owa-ows-gateway';
import { isFeatureEnabled } from 'owa-feature-flags';

const DELETEPLACE_ENDPOINT_URL: string = isFeatureEnabled('cal-mf-placesb2')
    ? 'SchedulingB2/api/v1.0/me/deleteplace'
    : 'Scheduling/api/v1.0/me/deleteplace';

export function deletePlace(personaId: string): Promise<Response> {
    const request = { Id: personaId };

    return makePostRequest(
        DELETEPLACE_ENDPOINT_URL,
        request,
        undefined /* correlationId */,
        false /* returnFullResponse */,
        undefined /* customHeaders */,
        undefined /* throwServiceError */,
        true /* sendPayloadAsBody */
    );
}
